import { Tooltip, Typography } from "@mui/material";

const Device = ({ fontSize, name }) => {
  return (
    <Tooltip title={name}>
      <Typography noWrap {...{ fontSize, sx: { cursor: "default" } }}>
        {name}
      </Typography>
    </Tooltip>
  );
};

export default Device;
